export default "__VITE_ASSET__f1986f6a__"